import { api } from "@/builders/axios";

export type SetupLessons = {
  order: number;
  title: string;
  topic_id: number;
  pass_mark: number;
  instructor_name: string;
  overview: string;
  duration_in_minutes: number;
  assessment_id: number;
  contents: Array<{
    data: string;
    note: string;
  }>;
};

const get = function (id: number) {
  return api.get<SetupLessons>(`setup/lessons/${id}`);
};

const put = function (id: number, data: SetupLessons) {
  return api.put(`/setup/lessons/${id}`, data);
};

const patch = function (id: number, data: Partial<SetupLessons>) {
  return api.patch(`/setup/lessons/${id}`, data);
};

const del = function (id: number) {
  return api.delete(`/setup/lessons/${id}`);
};

export const id = {
  get,
  put,
  patch,
  del,
};
